import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'formik';

export default function Error({ name }) {
  return (
    <div id='error-message' className='error__message'>
      <ErrorMessage id={`${name}-error`} name={name} />&nbsp;
    </div>
  );
}

Error.propTypes = {
  name: PropTypes.string.isRequired,
};
